import UUID from '../utils/uuid';
import { setTarget } from './dep';

export class Watcher {
    expOrFn: () => any;
    id: string;
    depIds: any;

    constructor(expOrFn: () => any) {
        this.id = `watcherId:${new UUID().id}`;
        this.expOrFn = expOrFn;
        this.depIds = new Set();
        this.get();
    }

    get() {
        setTarget(this);
        this.expOrFn();
        setTarget(null);
    }

    addDep(dep) {
        const id = dep.id;

        // 这里做判断是防止，在一个ticker中多次触发一个key的get方法，导致重复添加同一watcher
        if (!this.depIds.has(id)) {
            this.depIds.add(id);
            dep.addSub(this);
        }
    }

    update() {
        this.expOrFn();
    }
}
